import { render, staticRenderFns } from "./workflowFormWithProject.vue?vue&type=template&id=6aff538c"
import script from "./workflowFormWithProject.vue?vue&type=script&lang=js"
export * from "./workflowFormWithProject.vue?vue&type=script&lang=js"
import style0 from "./workflowFormWithProject.vue?vue&type=style&index=0&id=6aff538c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports